import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import { RequestWrapper } from "../../routers/request-wrapper";
import { Products, Product, CreateProduct, UpdateProduct, ProductsPriceOnly } from "./pages";

export const ProductsRouter = [
  <Route
    path="/products"
    element={
      <ProtectedRoute roles={["Any"]}>
        <RequestWrapper component={Products} />
      </ProtectedRoute>
    }
  />,

  <Route path="/product">
    <Route
      path=":id"
      element={
        <ProtectedRoute roles={["Any"]}>
          <Product />
        </ProtectedRoute>
      }
    />
    ,
    <Route
      path="create"
      element={
        <ProtectedRoute roles={["Any"]}>
          <CreateProduct />
        </ProtectedRoute>
      }
    />
    ,
    <Route
      path=":id/update"
      element={
        <ProtectedRoute roles={["Any"]}>
          <UpdateProduct />
        </ProtectedRoute>
      }
    />
  </Route>,
];

export const AdminProductsRouter = [
  <Route
    path="/products"
    element={
      <ProtectedRoute roles={["Any"]}>
        <RequestWrapper component={Products} />
      </ProtectedRoute>
    }
  />,

  <Route
    path="/products-price-only"
    element={
      <ProtectedRoute roles={["Any"]}>
        <RequestWrapper component={ProductsPriceOnly} />
      </ProtectedRoute>
    }
  />,

  <Route path="/product">
    <Route
      path=":id"
      element={
        <ProtectedRoute roles={["Any"]}>
          <Product />
        </ProtectedRoute>
      }
    />
    ,
    <Route
      path="create"
      element={
        <ProtectedRoute roles={["Any"]}>
          <CreateProduct />
        </ProtectedRoute>
      }
    />
    ,
    <Route
      path=":id/update"
      element={
        <ProtectedRoute roles={["Any"]}>
          <UpdateProduct />
        </ProtectedRoute>
      }
    />
  </Route>,
];

export const ClientProductsRouter = [
  <Route
    path="/products"
    element={
      <ProtectedRoute roles={["Any"]}>
        <RequestWrapper component={Products} />
      </ProtectedRoute>
    }
  />,

  <Route
    path="/products-price-only"
    element={
      <ProtectedRoute roles={["Any"]}>
        <RequestWrapper component={ProductsPriceOnly} />
      </ProtectedRoute>
    }
  />,

  <Route path="/product">
    <Route
      path=":id"
      element={
        <ProtectedRoute roles={["Any"]}>
          <Product />
        </ProtectedRoute>
      }
    />
    ,
  </Route>,
];
